import React, { useContext } from "react";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withTranslations from "../../../../../hocs/withTranslations";
import { useStrategyDashboardConfig } from "../../../../../lib/StrategyDashboard/StrategyDashboardContext";
import { stringifyUniversalTableUrlSettings } from "../../../../../lib/UniversalTable/buildUniversalTableUrlSettings";
import { mapStrategyPreviewPaginationToFullTable } from "../../../../../lib/UniversalTable/mapStrategyPreviewPaginationToFullTable";
import UniversalTableContext from "../../../../../lib/UniversalTable/UniversalTableContext";
import { ButtonWithArrow } from "../../../common/Typography";

const StrategyViewFullTableLink = ({ translate, locale }) => {
  const dashboard = useStrategyDashboardConfig();
  const { filters, search, sortBy, currentTabId, pagination } = useContext(
    UniversalTableContext
  );

  const baseUrl = UrlProvider.getLocalizedUrl(
    locale,
    `fe.${dashboard.web.urlPatternKeys.table.component}`,
    { locale }
  );
  const fullTableUrl =
    baseUrl +
    stringifyUniversalTableUrlSettings({
      currentTabId,
      search,
      filters,
      sortBy,
      pagination: mapStrategyPreviewPaginationToFullTable(pagination)
    });

  return (
    <div className="flex flex-col align-center w-full">
      <ButtonWithArrow
        href={fullTableUrl}
        withBackground
        className="mt-5 mb-6 w-full min-w-0 md:min-w-332 md:w-auto md:mt-8 md:mb-4"
      >
        {translate("dashboard_view_full_table")}
      </ButtonWithArrow>
    </div>
  );
};

export default withTranslations(StrategyViewFullTableLink);
